import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { CspReports } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/csp-reports")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <CspReports />
    </RouteGuard>
  ),
});
